var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28,
    r: 28,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 38.6665L15.9038 36.3684C15.4521 36.1425 15.1667 35.6808 15.1667 35.1758V30.3179C15.1667 29.7326 15.5485 29.2157 16.108 29.0436L19.5001 27.9998M20.5001 38.6665L19.5001 27.9998M20.5001 38.6665L20.6618 39.3133C20.9585 40.5004 22.0252 41.3332 23.2488 41.3332H27.1667M19.5001 27.9998L19.1667 23.9998C19.1667 18.8452 23.3454 14.6665 28.5001 14.6665C33.6547 14.6665 37.8334 18.8452 37.8334 23.9998L37.5001 27.9998M37.5001 27.9998L36.5001 38.6665L41.0964 36.3684C41.5481 36.1425 41.8334 35.6808 41.8334 35.1758V30.3179C41.8334 29.7326 41.4517 29.2157 40.8922 29.0436L37.5001 27.9998Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerService);
export default __webpack_public_path__ + "static/media/customer_service.546077e4b071ad0a590dad99c0c5ce94.svg";
export { ForwardRef as ReactComponent };